import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=44e6444c&scoped=true&"
import script from "./OpenApp.vue?vue&type=script&lang=js&"
export * from "./OpenApp.vue?vue&type=script&lang=js&"
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=44e6444c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6444c",
  null
  
)

export default component.exports